import { render, staticRenderFns } from "./DefaultBody.vue?vue&type=template&id=2503bbe2&scoped=true&"
import script from "./DefaultBody.vue?vue&type=script&lang=js&"
export * from "./DefaultBody.vue?vue&type=script&lang=js&"
import style0 from "./DefaultBody.vue?vue&type=style&index=0&id=2503bbe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503bbe2",
  null
  
)

export default component.exports